export default __webpack_public_path__ + "static/media/icon-settings.323d897b.svg";